import styles from "./loglist.module.css";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ItemCard from "./ItemCard";
import TableRowCard from "./TableRowCard";

const LogList = ({ filteredData, loadError, onRetry }) => {

    return (<div className={`${styles.IncomeListUnderSec}`}>

        <div className={`${styles.ListCardDivSec}`}>
            {filteredData?.map((item, index) => {
                return <ItemCard key={item?.id ?? index} item={item} />
            })}
        </div>

        <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 400 }}>Name</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 100 }}>Status</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Audience</TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }}>Analytics</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {filteredData?.map((item, index) => {
                        return <TableRowCard key={item?.id ?? index} item={item} />
                    })}
                </TableBody>
            </Table>
        </TableContainer>

        {filteredData.length === 0 && loadError && (<div className={`${styles.NoDataMain}`}>
            <p className={`${styles.NoDataText}`}>Something went wrong</p>
            <p className={`${styles.NoDataTextSub}`}>We couldn't load email analytics. Please try again.</p>
            <button type="button" className={`${styles.RetryBu}`} onClick={onRetry}>Retry</button>
        </div>)}

        {filteredData.length === 0 && !loadError && (<div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/no-prospect.png" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>Let's get started!</p>
            <p className={`${styles.NoDataTextSub}`}>You don't have any logs saved.</p>
        </div>)}

    </div>)
}

export default LogList;